import clientLogo1 from './Images/clientLogo1.jpg';
import clientLogo2 from './Images/clientLogo2.jpg';
import clientLogo3 from './Images/clientLogo3.jpg';
import clientLogo4 from './Images/clientLogo4.jpg';
import clientLogo5 from './Images/clientLogo5.jpg';
import clientLogo6 from './Images/clientLogo6.jpg';
import clientLogo7 from './Images/clientLogo7.jpg';
import clientLogo8 from './Images/clientLogo8.jpg';
import clientLogo9 from './Images/clientLogo9.jpg';
import clientLogo10 from './Images/clientLogo10.jpg';
/*import clientLogo11 from './Images/clientLogo11.jpg';*/
import clientLogo12 from './Images/clientLogo12.jpg';
import clientLogo13 from './Images/clientLogo13.jpg';
import clientLogo14 from './Images/clientLogo14.jpg';
import clientLogo15 from './Images/clientLogo15.jpg';
import clientLogo16 from './Images/clientLogo16.jpg';
/*import clientLogo17 from './Images/clientLogo17.jpg';
import clientLogo18 from './Images/clientLogo18.jpg';
import clientLogo19 from './Images/clientLogo19.jpg';
import clientLogo20 from './Images/clientLogo20.jpg';
import clientLogo21 from './Images/clientLogo21.jpg';
import clientLogo22 from './Images/clientLogo22.jpg';
import clientLogo23 from './Images/clientLogo23.jpg';
import clientLogo24 from './Images/clientLogo24.jpg';*/


import Service1 from './Images/service-1.webp';
import manageService1 from './Images/manage-service-1.webp';
import chooseService1 from './Images/service-1-why-choose.webp';
import ctaService1 from './Images/service-1-cta.webp';

import Service2 from './Images/service-2.webp';
import manageService2 from './Images/service-2-manage.webp';
import chooseService2 from './Images/service-2-why-choose.webp';
import ctaService2 from './Images/service-2-cta.webp';

import Service3 from './Images/service-3.webp';
import manageService3 from './Images/service-5-manage.webp';
import chooseService3 from './Images/service-3-why-choose.webp';
import ctaService3 from './Images/service-3-cta.webp';

import Service4 from './Images/service-4.webp';
import manageService4 from './Images/service-8-manage.webp';
import chooseService4 from './Images/service-4-why-choose.webp';
import ctaService4 from './Images/service-4-cta.webp';

import Service5 from './Images/service-5.webp';
import manageService5 from './Images/service-5-manage.webp';
import chooseService5 from './Images/service-5-why-choose.webp';
import ctaService5 from './Images/service-5-cta.webp';

import Service6 from './Images/service-6.webp';
import manageService6 from './Images/service-6-manage.webp';
import chooseService6 from './Images/service-6-why-choose.webp';
import ctaService6 from './Images/service-6-cta.webp';

import Service7 from './Images/service-7.webp';
import manageService7 from './Images/service-7-mamage.webp';
import chooseService7 from './Images/service-7-why-choose.webp';
import ctaService7 from './Images/service-7-cta.webp';

import Service8 from './Images/service-8.webp';
import manageService8 from './Images/service-8-manage.webp';
import chooseService8 from './Images/service-8-why-choose.webp';
import ctaService8 from './Images/service-8-cta.webp';

import industry1 from './Images/industry-1.webp';
import chooseIndustry1 from './Images/industry-1-why-choose.webp';
import ctaIndustry1 from './Images/industry-1-cta.webp';

import industry2 from './Images/industry-2.webp';
import chooseIndustry2 from './Images/industry-2-manage.webp';
import ctaIndustry2 from './Images/industry-2-cta.webp';

import industry3 from './Images/industry-3.webp';
import chooseIndustry3 from './Images/industry-3-manage.webp';
import ctaIndustry3 from './Images/industry-3-cta.webp';

import industry4 from './Images/industry-4.webp';
import chooseIndustry4 from './Images/industry-4-why-choose.webp';
import ctaIndustry4 from './Images/industry-4-cta.webp';

import industry5 from './Images/industry-5.webp';
import chooseIndustry5 from './Images/industry-5-manage.webp';
import ctaIndustry5 from './Images/industry-5-cta.webp';

import industry6 from './Images/industry-6.webp';
import chooseIndustry6 from './Images/industry-6-why-choose.webp';
import ctaIndustry6 from './Images/industry-6-cta.webp';

import industry7 from './Images/industry-7.webp';
import chooseIndustry7 from './Images/indsutry-7-manage.webp';
import ctaIndustry7 from './Images/industry-7-cta.webp';

import industry8 from './Images/industry-8.webp';
import chooseIndustry8 from './Images/industry-8-why-choose.webp';
import ctaIndustry8 from './Images/industry-8-cta.webp';

import industry9 from './Images/industry-9.webp';
import chooseIndustry9 from './Images/industry-9-why-choose.webp';
import ctaIndustry9 from './Images/industry-9-cta.webp';

import industry10 from './Images/industry-10.webp';
import chooseIndustry10 from './Images/industry-10-manage.webp';
import ctaIndustry10 from './Images/industry-10-cta.webp';


import { FiTruck, FiClock, FiHeadphones,FiPackage, FiLayers, FiMap, FiGlobe, FiAnchor, FiBox, FiSettings, FiBriefcase, FiFeather, FiActivity, FiTool, FiDroplet, FiShoppingCart, FiClipboard, FiDollarSign, FiUserCheck, FiRepeat, FiShield, FiFileText, FiBarChart2, FiMapPin, FiThermometer, FiTrendingUp, FiAlertTriangle, FiArchive, FiGrid} from "react-icons/fi";

export const services=[
    {
        metaTitle:"Full Truck Load Transportation Services | Shivam Transworld",
        metaDesc:"Dedicated full truck load transportation services for bulk consignments, offering faster transit, better cargo safety & pan-India delivery by Shivam Transworld.",
        slug:"full-truck-load",
        title:"Full Truck Load (FTL)",
        icon:<FiTruck />,
        introDesc:"Dedicated vehicles for large consignments ensuring faster transit, safety, and complete shipment control.",
        points:["Dedicated","Secure","Fast"],
        image:Service1,
        pageheading:"Full Truck Load (FTL) Transportation Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld provides reliable and dedicated Full Truck Load (FTL) transportation services designed for businesses with large-volume shipments. With a strong Pan-India network and a wide range of vehicle options, we ensure faster transit, enhanced safety, and complete control over your consignment—delivered on time, every time.",
        infoTitle:"What Is Full Truck Load Transportation?",
        infoDesc:"Full Truck Load (FTL) transportation involves allocating a dedicated vehicle for a single customer’s shipment, ensuring direct movement without load sharing, reduced handling, and improved delivery speed and security.",
        pointsSecHeading:"When Full Truck Load Transportation Makes Sense",
        pointsSecDesc:"FTL is ideal when your shipment requires exclusive space, faster delivery, and higher safety standards. It offers better control, fewer touchpoints, and predictable transit timelines.",
        pointsSecData:[
            {
      title: "High-Volume Shipments",
      desc:
        "Best suited for large or bulk consignments that require an entire truck."
    },
    {
      title: "Time-Sensitive Deliveries",
      desc:
        "Ensures quicker transit with minimal delays and no intermediate stops."
    },
    {
      title: "Fragile or High-Value Goods",
      desc:
        "Reduces handling, lowering the risk of damage or loss."
    },
    {
      title: "Direct Point-to-Point Movement",
      desc:
        "Ideal when goods need to move straight from origin to destination."
    },
    {
      title: "Operational Control",
      desc:
        "Suitable for businesses needing full visibility and control over shipments."
    }
        ],
    servicemanageBg:manageService1,
    serviceManageTitle:"How We Manage Full Truck Load Shipments",
    serviceManageDesc:"We follow a structured and transparent process to ensure smooth execution and reliable delivery of every FTL shipment.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding shipment size, timelines, and selecting the most efficient route.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning the right truck and scheduling pickups to meet delivery commitments.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Continuous coordination and monitoring throughout the journey.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Safe unloading, on-time delivery, and shipment confirmation at destination.",
    },
  ],
  whychooseImg:chooseService1,
  whychooseTitle:"Why Choose Shivam Transworld for Full Truck Load Transportation",
  whychooseDesc:"With over 11 years of experience and a strong fleet network, we deliver dependable FTL services tailored to your business needs.",
  whychoosePoints:[
    "Dedicated trucks with complete shipment control",
    "Pan-India coverage with reliable transit timelines",
    "Wide range of vehicle options (4 to 14 tyres)",
    "Experienced operations and coordination team",
    "Trusted by leading manufacturers, traders, and exporters"
  ],
  ctaImage:ctaService1,
  ctaTitle:"Need a Dedicated Truck for Your Shipment?",
  ctaText:"Whether you’re moving bulk goods or time-critical consignments, our Full Truck Load solutions ensure safe, fast, and hassle-free transportation. Connect with our team today to get a customized quote and move your shipment with confidence.",
  cta: {
    primary: {
      text: "Get a Quote",
      link: "/enquiry#enquiry-form",
    },
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  },
    },
     {
        metaTitle:"Part Truck Load (PTL / LTL) Services | Shivam Transworld",
        metaDesc:"Cost-effective part truck load transportation services for smaller consignments, offering reliable shared-load deliveries across India by Shivam Transworld.",
        slug:"part-truck-load",
        title:"Part Truck Load (PTL / LTL)",
        icon:<FiPackage />,
        introDesc:"Cost-effective shared transportation for smaller shipments with flexible and reliable delivery.",
        points:["Economical","Flexible","Reliable"],
        image:Service2,
        pageheading:"Part Truck Load (PTL / LTL) Transportation Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld offers cost-effective and reliable Part Truck Load (PTL / LTL) transportation services for businesses with smaller or frequent shipments. By sharing truck space, we help you reduce transportation costs while ensuring safe handling, planned transit, and dependable delivery across Pan-India routes.",
        infoTitle:"What Is Part Truck Load Transportation?",
        infoDesc:"Part Truck Load (PTL / LTL) transportation allows multiple shipments from different customers to share the same vehicle, making it an economical and flexible solution for consignments that do not require a full truck.",
        pointsSecHeading:"When Part Truck Load Transportation Makes Sense",
        pointsSecDesc:"PTL is ideal when shipments are smaller in size but still require professional handling and reliable delivery. It balances affordability with operational efficiency.",
        pointsSecData:[
            {
      title: "Smaller Shipment Volumes",
      desc:
        "Suitable when your consignment doesn’t fill an entire truck."
    },
    {
      title: "Cost-Sensitive Transportation",
      desc:
        "Helps reduce freight costs by paying only for the space used."
    },
    {
      title: "Regular or Frequent Dispatches",
      desc:
        "Ideal for businesses with ongoing, smaller deliveries."
    },
    {
      title: "Flexible Delivery Timelines",
      desc:
        "Works well when delivery is planned rather than urgent."
    },
    {
      title: "Wide Distribution Needs",
      desc:
        "Perfect for servicing multiple locations across regions."
    }
        ],
    servicemanageBg:manageService2,
    serviceManageTitle:"How We Manage Part Truck Load Shipments",
    serviceManageDesc:"We follow a structured process to ensure efficient consolidation, smooth transit, and timely delivery of PTL shipments.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Evaluating shipment size, destination, and selecting optimized consolidation routes.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning suitable vehicles and scheduling movements for efficient load sharing.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Coordinated pickups and careful monitoring throughout transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Secure unloading and delivery with confirmation at the destination.",
    },
  ],
  whychooseImg:chooseService2,
  whychooseTitle:"Why Choose Shivam Transworld for Part Truck Load Transportation",
  whychooseDesc:"With strong network coverage and experienced handling, we make part load transportation reliable and hassle-free.",
  whychoosePoints:[
    "Cost-effective shared transportation solutions",
    "Pan-India network of hubs and delivery points",
    "Safe handling with reduced risk of damage",
    "Transparent coordination and reliable schedules",
    "Trusted by SMEs, traders, and growing businesses"
  ],
  ctaImage:ctaService2,
  ctaTitle:"Looking for Cost-Effective Part Load Transport?",
  ctaText:"Move your smaller consignments efficiently without paying for a full truck. Our PTL solutions are designed to save costs while ensuring dependable delivery. Get in touch with our team today for a customized quote and expert support.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  },
    },
     {
        metaTitle:"Integrated Logistics Solutions | Shivam Transworld",
        metaDesc:"End-to-end logistics solutions covering transportation, planning, coordination to support smooth, efficient movement of goods across India by Shivam Transworld.",
        slug:"logistics-solutions",
        title:"Logistics Solutions",
        icon:<FiLayers />,
        introDesc:"End-to-end logistics planning and execution tailored to meet diverse business requirements.",
        points:["Integrated","Scalable","Strategic"],
        image:Service3,
        pageheading:"Integrated Logistics Solutions",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld delivers integrated logistics solutions that connect transportation, coordination, and execution into one seamless process. From planning to final delivery, we manage every movement of your goods with efficiency, visibility, and reliability—helping your business operate smarter and scale faster.",
        infoTitle:"What Is Integrated Logistics Solutions?",
        infoDesc:"Integrated logistics solutions combine multiple transportation and logistics services into a single, coordinated system. Instead of managing different vendors, businesses benefit from one partner handling planning, execution, and delivery end to end.",
        pointsSecHeading:"When Integrated Logistics Makes Sense",
        pointsSecDesc:"Integrated logistics is ideal for businesses that need consistency, control, and efficiency across their entire supply chain.",
        pointsSecData:[
            {
      title: "Complex Supply Chains",
      desc:
        "Suitable when multiple routes, locations, or transport modes are involved."
    },
    {
      title: "Growing Businesses",
      desc:
        "Helps streamline operations as shipment volumes increase."
    },
    {
      title: "Cost & Time Optimization",
      desc:
        "Reduces inefficiencies through centralized planning and execution."
    },
    {
      title: "Multi-Service Requirements",
      desc:
        "Ideal when transportation, coordination, and delivery must work together."
    },
    {
      title: "Pan-India Distribution",
      desc:
        "Best for businesses operating across multiple regions and markets."
    }
        ],
    servicemanageBg:manageService3,
    serviceManageTitle:"How We Deliver End-to-End Logistics Solutions",
    serviceManageDesc:"Our structured approach ensures smooth coordination and reliable execution across every logistics stage.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding business needs and designing the most efficient logistics flow.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning the right vehicles and schedules to match shipment requirements.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Managing pickups and monitoring shipments throughout transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Ensuring safe delivery with timely confirmation and closure.",
    },
  ],
  whychooseImg:chooseService3,
  whychooseTitle:"Why Choose Shivam Transworld for Integrated Logistics",
  whychooseDesc:"With proven experience and a strong operational network, we deliver logistics solutions that are reliable, scalable, and business-focused.",
  whychoosePoints:[
    "End-to-end logistics under one trusted partner",
    "Pan-India coverage with strong fleet network",
    "Customized solutions for diverse industries",
    "Experienced team ensuring smooth coordination",
    "Consistent, transparent, and reliable execution"
  ],
  ctaImage:ctaService3,
  ctaTitle:"Need a Complete Logistics Solution?",
  ctaText:"Simplify your supply chain with a single logistics partner who manages everything from start to finish. Connect with Shivam Transworld today to get a customized logistics solution built around your business needs.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
    },
  },
     {
        metaTitle:"First & Last Mile Logistics Services | Shivam Transworld",
        metaDesc:"Reliable first & last-mile logistics services ensuring smooth pickup and timely delivery from factories, warehouses, & ports across India by Shivam Transworld.",
        slug:"first-last-mile-logistics",
        title:"First & Last Mile Logistics",
        icon:<FiMap />,
        introDesc:"Seamless pickup and final delivery solutions ensuring smooth movement from origin to destination.",
        points:["Seamless","Timely","Dependable"],
        image:Service4,
        pageheading:"First & Last Mile Logistics Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld offers end-to-end first mile and last mile logistics services for import, export, and EXIM customers, ensuring safe and timely cargo movement from origin to port of loading, and from port of landing to the customer’s destination, pan-India.",
        infoTitle:"What Is First & Last Mile Logistics?",
        infoDesc:"First & Last Mile logistics refers to the initial pickup of goods from the origin point and the final delivery to the destination. These stages are crucial for ensuring speed, accuracy, and customer satisfaction in the overall logistics process.",
        pointsSecHeading:"When First & Last Mile Logistics Is Essential",
        pointsSecDesc:"First & Last Mile services play a vital role where precision, speed, and coordination are critical to successful deliveries.",
        pointsSecData:[
            {
      title: "Export & Import Shipments",
      desc:
        "Essential for port pickups, ICD movements, and final destination delivery."
    },
            {
      title: "Multiple Pickup or Delivery Points",
      desc:
        "Ideal for shipments involving warehouses, factories, ports, or distribution centers."
    },
    {
      title: "Urban & Remote Locations",
      desc:
        "Ensures reach across cities, towns, and hard-to-access areas."
    },
    {
      title: "Time-Sensitive Deliveries",
      desc:
        "Critical when delivery timelines directly impact operations or customers."
    },
    {
      title: "E-commerce & Distribution Needs",
      desc:
        "Supports frequent pickups and last-mile deliveries."
    },
        ],
    servicemanageBg:manageService4,
    serviceManageTitle:"How We Manage First & Last Mile Deliveries",
    serviceManageDesc:"We follow a structured approach to ensure seamless coordination from the very first pickup to the final handover.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding delivery points and planning efficient routes.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Deploying the right vehicle type and scheduling for smooth operations.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Coordinating pickups and monitoring movement throughout transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Ensuring secure delivery with timely confirmation at the destination.",
    },
  ],
  whychooseImg:chooseService4,
  whychooseTitle:"Why Choose Shivam Transworld for First & Last Mile Logistics",
  whychooseDesc:"Our experience, network strength, and attention to detail make us a reliable partner for critical logistics movements.",
  whychoosePoints:[
    "Pan-India pickup and delivery coverage",
    "Flexible vehicle options for all shipment sizes",
    "Strong local coordination and execution",
    "Reliable, timely, and secure deliveries",
    "Trusted by manufacturers, traders, and exporters"
  ],
  ctaImage:ctaService4,
  ctaTitle:"Need Reliable First & Last Mile Support?",
  ctaText:"Ensure your goods move smoothly from the first point to the final destination with a trusted logistics partner. Connect with Shivam Transworld today for dependable First & Last Mile logistics solutions tailored to your business needs.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Multimodal Transportation Solutions | Shivam Transworld",
        metaDesc:"Flexible multimodal transportation solutions combining road and air services to ensure efficient, time-bound cargo movement across India by Shivam Transworld.",
        slug:"multimodal-transportation-solutions",
        title:"Multimodal Transportation",
         icon:<FiGlobe />,
        introDesc:"Integrated surface and air transport solutions for optimized transit time and efficiency.",
        points:["Optimized","Agile","Connected"],
        image:Service5,
        pageheading:"Multimodal Transportation Solutions",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld offers smart and efficient multimodal transportation solutions by integrating surface and air transport to optimize speed, cost, and reliability. We manage complex movements with seamless coordination, ensuring your shipments reach their destination through the most efficient transport combination.",
        infoTitle:"What Is Multimodal Transportation?",
        infoDesc:"Multimodal transportation involves moving goods using two or more modes of transport under a single coordinated logistics plan, improving efficiency while reducing transit time, handling risks, and overall transportation costs.",
        pointsSecHeading:"When Multimodal Transport Makes Sense",
        pointsSecDesc:"Multimodal transport is ideal when speed, reach, and efficiency are critical across long distances or complex routes.",
        pointsSecData:[
            {
      title: "Long-Distance Shipments",
      desc:
        "Suitable for goods moving across regions or states with optimized routing."
    },
    {
      title: "Time-Critical Deliveries",
      desc:
        "Combines air and surface transport to meet tight deadlines."
    },
    {
      title: "Cost Optimization Needs",
      desc:
        "Balances faster transit with cost-effective transport modes."
    },
    {
      title: "Complex Supply Chains",
      desc:
        "Best for shipments involving multiple transfer points or hubs."
    },
    {
      title: "Pan-India & Beyond Reach",
      desc:
        "Enables efficient movement across diverse geographies."
    }
        ],
    servicemanageBg:manageService5,
    serviceManageTitle:"How We Coordinate Multimodal Shipments",
    serviceManageDesc:"We manage multimodal transportation through structured planning and precise coordination at every stage.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Analyzing shipment needs and designing the most efficient multimodal route.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Selecting appropriate transport modes and scheduling seamless transfers.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Coordinating movement between modes with continuous monitoring.",
    },
    {
      title: "Delivery & Confirmation",
      desc: " Ensuring safe final delivery with confirmation at destination.",
    },
  ],
  whychooseImg:chooseService5,
  whychooseTitle:"Why Choose Shivam Transworld for Multimodal Transportation",
  whychooseDesc:"Our experience and network strength allow us to deliver reliable multimodal solutions with complete coordination.",
  whychoosePoints:[
    "Integrated surface and air transportation expertise",
    "Optimized routes for time and cost efficiency",
    "Single-point coordination for complex movements",
    "Pan-India network with reliable execution",
    "Trusted logistics partner across industries"
  ],
  ctaImage:ctaService5,
  ctaTitle:"Need Flexible Multimodal Transport Solutions?",
  ctaText:"Whether speed, cost, or reach is your priority, our multimodal transportation solutions are designed to meet your business needs. Connect with Shivam Transworld today for a customized quote and expert logistics support.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Inbound & Outbound Logistics Services | Shivam Transworld",
        metaDesc:"Efficient inbound and outbound logistics services supporting raw material movement, finished goods dispatch, and supply chain continuity by Shivam Transworld.",
        slug:"inbound-outbound-logistics",
        title:"Inbound & Outbound Logistics",
        icon:<FiAnchor />,
        introDesc:"Streamlined movement of goods into and out of your business with complete coordination and visibility.",
        points:["Coordinated","Transparent","Reliable"],
        image:Service6,
        pageheading:"Inbound & Outbound Logistics Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld provides efficient Inbound & Outbound logistics services that ensure smooth movement of goods into and out of your business. From raw material pickups to finished goods deliveries, we manage every stage with precision, coordination, and complete visibility across Pan-India operations.",
        infoTitle:"What Is Inbound & Outbound Logistics?",
        infoDesc:"Inbound logistics focuses on the planned transportation and coordination of raw materials or goods coming into your facility, while outbound logistics manages the timely movement of finished products from your warehouse or plant to distributors, customers, or ports with complete visibility and control.",
        pointsSecHeading:"When Inbound & Outbound Logistics Is Required",
        pointsSecDesc:"Inbound & Outbound logistics is essential for maintaining smooth operational continuity, efficient inventory flow, and timely, reliable deliveries that keep business operations running without disruption.",
        pointsSecData:[
            {
      title: "Manufacturing Operations",
      desc:
        "Ensures timely inflow of raw materials and dispatch of finished goods."
    },
    {
      title: "Distribution & Warehousing",
      desc:
        "Supports regular inventory movement between warehouses and markets."
    },
    {
      title: "Export & Import Activities",
      desc:
        "Manages port-to-plant and plant-to-port logistics efficiently."
    },
    {
      title: "High-Volume Shipments",
      desc:
        "Ideal for businesses with frequent inbound and outbound consignments."
    },
    {
      title: "Pan-India Supply Chains",
      desc:
        "Enables smooth logistics coordination across multiple locations."
    }
        ],
    servicemanageBg:manageService6,
    serviceManageTitle:"How We Manage Inbound & Outbound Shipments",
    serviceManageDesc:"Our structured logistics approach ensures efficient coordination, clear communication, and reliable execution at every stage, minimizing delays and ensuring smooth, hassle-free operations.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding inbound and outbound needs to plan optimized routes.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning suitable vehicles and scheduling movements as per operational timelines.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Managing pickups, dispatches, and continuous transit monitoring.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Ensuring secure, timely delivery with confirmation at the destination.",
    },
  ],
  whychooseImg:chooseService6,
  whychooseTitle:"Why Choose Shivam Transworld for Inbound & Outbound Logistics",
  whychooseDesc:"With proven industry experience and a strong operational network, we help businesses maintain uninterrupted supply chain flow, improve efficiency, and ensure consistent, on-time movement of goods across all locations.",
  whychoosePoints:[
    "End-to-end inbound and outbound logistics management",
    "Pan-India coverage with a strong fleet network",
    "Reliable scheduling and timely deliveries",
    "Transparent coordination and shipment visibility",
    "Trusted partner for manufacturers, traders, and exporters"
  ],
   /*whychooseTitle:"Warehousing & Storage Solutions",
  whychooseDesc:"Our warehousing and storage solutions are designed to seamlessly support import, export, and EXIM logistics by providing secure, flexible, and well-coordinated storage and distribution services. With strategically located warehouses across India, we enable smooth cargo movement from customer locations to ports and from ports to final destinations, ensuring efficiency, safety, and supply chain continuity.Warehousing Services Include:",
  whychoosePoints:[
    "Secure, compliant, and well-managed warehousing facilities",
    "Short-term and long-term storage solutions",
    "Professional cargo handling, loading, and unloading",
    "Inventory management and dispatch coordination",
    "Integrated support with first-mile and last-mile logistics",
    "Pan-India warehousing and distribution coverage"
  ],*/
  ctaImage:ctaService6,
  ctaTitle:"Need Streamlined Inbound & Outbound Logistics?",
  ctaText:"Simplify your supply chain operations with a logistics partner who understands both inbound and outbound movement. Connect with Shivam Transworld today to get a customized quote and expert support for your logistics needs.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     /*{
        metaTitle:"Project & Heavy Cargo Logistics Services | Shivam Transworld",
        metaDesc:"Specialized project and heavy cargo logistics services for oversized and high-value shipments requiring careful planning and execution by Shivam Transworld.",
        slug:"project-heavy-cargo-logistics",
        title:"Project & Heavy Cargo Logistics",
        icon:<FiTruck />,
        introDesc:"Specialized transport for oversized and heavy cargo with precise planning and execution.",
        image:Service7,
        pageheading:"Project & Heavy Cargo Logistics Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld delivers specialized Project & Heavy Cargo logistics services designed to handle oversized, high-value, and complex shipments with complete precision and care. Supported by detailed planning, the right vehicle selection, and strong on-ground coordination, we ensure safe, compliant, and timely movement of heavy cargo across Pan-India routes, even in the most challenging conditions.",
        infoTitle:"What Is Project & Heavy Cargo Logistics?",
        infoDesc:"Project & Heavy Cargo logistics refers to the transportation of oversized, overweight, or technically complex cargo that requires in-depth planning, detailed route surveys, special permits, specialized equipment, and carefully controlled execution to ensure smooth, secure, and completely disruption-free delivery across all stages of the journey.",
        pointsSecHeading:"When Project & Heavy Cargo Logistics Is Required",
        pointsSecDesc:"Project & Heavy Cargo logistics becomes essential when cargo dimensions, weight, or sensitivity exceed standard transportation capabilities, requiring specialized planning, equipment, permits, and expert handling to ensure safe, timely, and efficient delivery.",
        pointsSecData:[
            {
      title: "Oversized or Overweight Cargo",
      desc:
        "Ideal for large machinery, industrial equipment, and heavy structures."
    },
    {
      title: "Infrastructure & Industrial Projects",
      desc:
        "Essential for power plants, refineries, factories, and large construction projects."
    },
    {
      title: "Time-Bound Project Deliveries",
      desc:
        "Critical when shipments are aligned with strict project schedules and milestones."
    },
    {
      title: "Route & Permit Constraints",
      desc:
        " Required when movements involve special permissions, escorts, or route modifications."
    },
    {
      title: "High-Value or Sensitive Equipment",
      desc:
        "Ensures controlled handling, safety, and risk mitigation throughout transit."
    }
        ],
    servicemanageBg:manageService7,
    serviceManageTitle:"How We Manage Project & Heavy Cargo Movements",
    serviceManageDesc:"We follow a detailed, well-coordinated, and safety-focused approach, combining meticulous planning, real-time monitoring, and expert handling to ensure flawless execution of every project and heavy cargo movement, regardless of size or complexity.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Evaluating cargo specifications, route feasibility, regulatory approvals, and risk factors.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Deploying suitable trailers and specialized vehicles based on cargo size, weight, and handling needs.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Managing loading operations, escort arrangements, and continuous monitoring during transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Ensuring safe unloading, accurate placement at site, and final delivery confirmation.",
    },
  ],
  whychooseImg:chooseService7,
  whychooseTitle:"Why Choose Shivam Transworld for Project & Heavy Cargo Logistics",
  whychooseDesc:"With proven industry experience and strong execution capabilities, we serve as a dependable and trusted partner for complex, high-value, and mission-critical cargo movements across diverse industries and project environments.",
  whychoosePoints:[
    "Expertise in oversized and heavy cargo transportation",
    "Detailed planning with safety and compliance focus",
    "Strong Pan-India operational and partner network",
    "Experienced team handling complex logistics challenges",
    "Trusted by industrial, infrastructure, and project-based clients"
  ],
  ctaImage:ctaService7,
  ctaTitle:"Need Expert Support for Heavy Cargo Movement?",
  ctaText:"Move your critical, oversized, and heavy cargo with confidence through a logistics partner that understands complexity, precision, and accountability. Connect with Shivam Transworld today to receive expert consultation and customized Project & Heavy Cargo logistics solutions tailored to your project requirements.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },*/
     {
        metaTitle:"Warehousing & Storage Solutions | Shivam Transworld",
        metaDesc:"Specialized Warehousing & Storage Solutions for oversized and high-value shipments requiring careful planning and execution by Shivam Transworld.",
        slug:"warehousing-storage-solutions",
        title:"Warehousing & Storage Solutions",
        icon:<FiTruck />,
        introDesc:"Specialized transport for warehousing & storage solutions with precise planning and execution.",
        image:Service7,
        pageheading:"Warehousing & Storage Solutions",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld offers secure, flexible, and end-to-end warehousing & storage solutions designed to support import, export, and EXIM logistics operations. From short-term holding to long-term storage and distribution, we ensure safe cargo handling, efficient inventory control, and smooth movement of goods across the supply chain. With strategically located warehouses across India, we help businesses move cargo seamlessly from customer locations to ports and from ports to final destinations—reliably and on time.",
        infoTitle:"What Are Warehousing & Storage Solutions?",
        infoDesc:"Warehousing & storage solutions involve the secure storage, handling, and management of goods before, during, or after transportation. These services support efficient supply chain operations by providing safe facilities, organized inventory control, cargo handling, and timely dispatch, ensuring goods are readily available when required for distribution, import, or export activities.",
        pointsSecHeading:"When Warehousing & Storage Solutions Make Sense",
        pointsSecDesc:"Warehousing services are essential when businesses require secure storage, structured inventory management, and smooth coordination between transportation and distribution. They help reduce transit delays, manage stock efficiently, and maintain uninterrupted logistics flow.",
        pointsSecData:[
            {
      title: "Import & Export Cargo Storage",
      desc:
        "Temporary or long-term storage for EXIM shipments awaiting clearance or dispatch."
    },
    {
      title: "Short-Term & Long-Term Storage Needs",
      desc:
        "Flexible storage solutions based on seasonal demand or business requirements."
    },
    {
      title: "Cargo Consolidation & Distribution",
      desc:
        "Organized handling and dispatch of goods to multiple destinations."
    },
    {
      title: "Inventory Management Support",
      desc:
        "Controlled storage with tracking and dispatch coordination."
    },
    {
      title: "First Mile & Last Mile Integration",
      desc:
        "Seamless movement of goods between warehouses, ports, and delivery locations."
    }
        ],
    servicemanageBg:manageService7,
    serviceManageTitle:"How We Manage Warehousing & Storage Solutions",
    serviceManageDesc:"We follow a systematic and well-coordinated approach to ensure goods are stored, handled, and dispatched safely and efficiently, with full visibility at every stage.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding cargo type, volume, and duration to allocate suitable warehousing space.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning secure storage areas with proper labeling and handling protocols.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Professional loading, unloading, and movement of goods within the facility.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Timely release and coordination with transportation teams for onward delivery.",
    },
  ],
  whychooseImg:chooseService7,
  whychooseTitle:"Why Choose Shivam Transworld for Warehousing & Storage Solutions",
  whychooseDesc:"With strong infrastructure, experienced teams, and pan-India reach, we provide reliable warehousing support that strengthens supply chain efficiency and cargo safety.",
  whychoosePoints:[
    "Secure and compliant warehousing facilities",
    "Short-term and long-term storage flexibility",
    "Professional cargo handling and safety standards",
    "Integrated first mile and last mile logistics support",
    "Pan-India warehousing and distribution coverage"
  ],
  ctaImage:ctaService7,
  ctaTitle:"Looking for End-to-End Logistics Support?",
  ctaText:"Simplify your storage and distribution needs with Shivam Transworld. Get in touch with our team for customized warehousing & storage solutions that ensure secure handling, efficient inventory management, and seamless cargo movement across India.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     /*{
        metaTitle:"Door-to-Door Delivery Services | Shivam Transworld",
        metaDesc:"Reliable door-to-door delivery services offering complete pickup-to-delivery transportation support for businesses across India by Shivam Transworld.",
        slug:"door-to-door-delivery-services",
        title:"Door-to-Door Delivery ",
        icon:<FiBox />,
        introDesc:"Complete pickup-to-delivery transportation from origin to destination.",
        image:Service8,
        pageheading:"Door-to-Door Delivery Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld offers reliable and hassle-free door-to-door delivery services, ensuring your goods are picked up from the origin and delivered directly to the final destination without intermediaries. With end-to-end coordination, Pan-India coverage, and a versatile fleet, we simplify logistics and provide complete peace of mind for businesses of all sizes.",
        infoTitle:"What Is Door-to-Door Delivery Services?",
        infoDesc:"Door-to-door delivery is a comprehensive transportation solution where the logistics provider manages the entire shipment journey—from pickup at the sender’s location to final delivery at the receiver’s doorstep. It eliminates the need for multiple service providers, ensuring smoother coordination, reduced handling, and timely delivery.",
        pointsSecHeading:"When Door-to-Door Delivery Transportation Makes Sense",
        pointsSecDesc:"Door-to-door delivery is ideal when businesses need a seamless, single-point logistics solution that saves time, reduces operational complexity, and ensures reliable delivery. It is especially useful for shipments that require careful handling, clear accountability, and consistent timelines across the entire journey.",
        pointsSecData:[
            {
      title: "End-to-End Accountability",
      desc:
        "One logistics partner responsible from pickup to final delivery."
    },
    {
      title: "Time-Sensitive Shipments",
      desc:
        "Faster coordination and reduced delays for urgent deliveries."
    },
    {
      title: "Multiple Pickup or Delivery Points",
      desc:
        "Simplified management for complex shipment routes."
    },
    {
      title: "Limited In-House Logistics Resources",
      desc:
        "Outsourcing complete transportation management."
    },
    {
      title: "High-Value or Sensitive Goods",
      desc:
        "Reduced handling and better control throughout transit."
    }
        ],
    servicemanageBg:manageService8,
    serviceManageTitle:"How We Manage Door-to-Door Shipments",
    serviceManageDesc:"Our structured and customer-focused approach ensures every door-to-door shipment is executed smoothly, safely, and on schedule. From planning to final confirmation, we manage each stage with precision and transparency.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Understanding shipment needs and planning the most efficient route.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning the right vehicle based on cargo type, volume, and timelines.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Coordinated pickup, continuous monitoring, and proactive communication during transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Safe final delivery with proper documentation and delivery confirmation.",
    },
  ],
  whychooseImg:chooseService8,
  whychooseTitle:"Why Choose Shivam Transworld for Door-to-Door Delivery",
  whychooseDesc:"With proven experience and strong operational capabilities, we deliver dependable door-to-door logistics solutions tailored to your business needs.",
  whychoosePoints:[
    "Single-point coordination from start to finish",
    "Pan-India service coverage",
    "Flexible fleet options for all shipment sizes",
    "Timely, safe, and reliable deliveries",
    "Transparent communication and execution"
  ],
  ctaImage:ctaService8,
  ctaTitle:"Looking for End-to-End Delivery Support?",
  ctaText:"Let Shivam Transworld handle your complete door-to-door transportation needs with efficiency and reliability. Connect with our team today to get a customized solution that ensures smooth pickup and timely delivery—every time.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },*/
     {
        metaTitle:"Packers & Movers Services | Shivam Transworld",
        metaDesc:"Reliable packers & movers services offering complete pickup-to-delivery transportation support for businesses across India by Shivam Transworld.",
        slug:"packers-and-movers-services",
        title:"Packers & Movers Services",
        icon:<FiBox />,
        introDesc:"Complete pickup-to-delivery transportation from origin to destination.",
        image:Service8,
        pageheading:"Packers & Movers Services",
        subheading:"OUR SERVICE",
        subText:"Shivam Transworld provides professional, reliable, and end-to-end packers & movers services designed to make relocation smooth, secure, and stress-free. From careful packing and safe handling to timely transportation and delivery, we manage every aspect of the moving process with precision and care. Whether it’s a household move, office relocation, or vehicle transportation, our experienced team ensures your belongings reach their destination safely and on schedule.",
        infoTitle:"What Are Packers & Movers Services?",
        infoDesc:"Packers & movers services cover the complete relocation process, including packing, loading, transportation, unloading, and final delivery of goods. These services are designed to minimize damage risks, save time, and provide peace of mind by using proper packing materials, skilled manpower, and well-planned transportation methods for both short- and long-distance moves.",
        pointsSecHeading:"When Packers & Movers Services Makes Sense",
        pointsSecDesc:"Packers & movers services are ideal when a relocation requires professional handling, structured planning, and reliable execution. They help individuals and businesses move efficiently while avoiding common relocation challenges such as damage, delays, or mismanagement.",
        pointsSecData:[
            {
      title: "Household Relocation",
      desc:
        "Secure shifting of furniture, appliances, electronics, and personal belongings."
    },
    {
      title: "Office & Commercial Moves",
      desc:
        "Organized movement of office furniture, equipment, and important documents."
    },
    {
      title: "Intercity or Interstate Relocation",
      desc:
        "Smooth long-distance moves with planned routes and timelines."
    },
    {
      title: "Fragile & High-Value Items",
      desc:
        "Special packing and handling for delicate or valuable goods."
    },
    {
      title: "Bike Packaging & Transportation",
      desc:
        "Safe, damage-free packing and transport of two-wheelers."
    }
        ],
    servicemanageBg:manageService8,
    serviceManageTitle:"How We Manage Packers & Movers Services",
    serviceManageDesc:"We follow a structured and well-coordinated approach to ensure every relocation is executed smoothly, safely, and on time. Our team handles each step with attention to detail and clear communication.",
    serviceManagePoints:[{
      title: "Requirement Assessment & Route Planning",
      desc: "Evaluating the move size, distance, and specific requirements to plan the most efficient route.",
    },
    {
      title: "Vehicle Allocation & Scheduling",
      desc: "Assigning suitable vehicles based on load type, volume, and delivery timelines.",
    },
    {
      title: "Pickup & In-Transit Coordination",
      desc: "Careful loading, secure packaging, and continuous coordination during transit.",
    },
    {
      title: "Delivery & Confirmation",
      desc: "Safe unloading, placement assistance (if required), and final delivery confirmation.",
    },
  ],
  whychooseImg:chooseService8,
  whychooseTitle:"Why Choose Shivam Transworld for Packers & Movers Services",
  whychooseDesc:"Our experience, trained teams, and dependable execution make us a trusted choice for relocation services. We focus on safety, efficiency, and customer satisfaction at every stage of the move.",
  whychoosePoints:[
    "Professional packing materials and techniques",
    "Experienced manpower for safe handling",
    "Bike packaging & transportation expertise",
    "Pan-India relocation support",
    "Timely delivery with transparent coordination"
  ],
  ctaImage:ctaService8,
  ctaTitle:"Looking for End-to-End Delivery Support?",
  ctaText:"Make your relocation simple and worry-free with Shivam Transworld. Contact our team today to get a customized packers & movers solution tailored to your needs, ensuring safe packing, smooth transportation, and timely delivery from start to finish.",
  cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    }
]

export const industries=[
    {
        metaTitle:"Logistics Solutions for Manufacturing & Engineering",
        metaDesc:"Reliable transportation & logistics support for manufacturing & engineering businesses, aligned with production schedules & bulk movement by Shivam Transworld.",
        slug:"manufacturing-engineering",
        title:"Manufacturing & Engineering",
        icon: <FiSettings />,
        image:industry1,
        pageheading:"Logistics Solutions for Manufacturing & Engineering Businesses",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld offers specialized logistics solutions for manufacturing and engineering businesses, ensuring the seamless movement of raw materials, components, and finished products. With extensive Pan-India coverage, experienced operations teams, and tailored transportation strategies, we help manufacturers maintain efficiency, reduce delays, and streamline their supply chains.",
        challengeTitle:"Transportation Challenges in Manufacturing & Engineering",
        challengeDesc:"Manufacturing and engineering companies often face complex logistics challenges that can impact production timelines and operational efficiency. Shivam Transworld helps overcome these challenges with reliable, end-to-end solutions.",
        challengePoints:[{
      icon:<FiTruck />,
      heading: "Bulk Material Handling",
      text: "Managing the transportation of large volumes of raw materials safely and efficiently.",
    },
    {
     icon: <FiClock />,
      heading: "Time-Sensitive Deliveries",
      text: "Ensuring timely arrival of components to avoid production delays.",
    },
    {
      icon:<FiRepeat />,
      heading: "Multiple Pickups & Deliveries",
      text: "Coordinating shipments across multiple suppliers, factories, and warehouses.",
    },
   {
      icon:<FiShield />,
      heading: "Safety & Compliance",
      text: "Handling heavy or sensitive machinery while adhering to safety and regulatory standards.",
    },
  ],
  supportTitle:"How We Support Manufacturing & Engineering Operations",
  supportDesc:"We provide end-to-end logistics support tailored to the specific needs of manufacturing and engineering operations, ensuring materials, components, and finished products move smoothly, efficiently, and without disruption through the entire supply chain.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "For bulk consignments and large-scale shipments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for regular smaller movements."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Streamlining materials coming in and finished goods going out."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Ensuring seamless pickup from suppliers and delivery to production units."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to manufacturing facilities, warehouses, or storage locations."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Manufacturing",
  useCaseDesc:"Our logistics solutions support a wide range of manufacturing needs, helping businesses optimize operations, improve efficiency, and significantly reduce supply chain risks across all stages of production and distribution.",
  useCasePoints:[
    {
      heading:"Raw Material Transport",
      text:"Efficient movement of raw materials from suppliers to production units."
    },
     {
      heading:"Component Delivery",
      text:"Timely supply of critical parts and components to manufacturing lines."
    },
     {
      heading:"Finished Goods Distribution",
      text:"Reliable transport of completed products to distributors, dealers, or clients."
    },
     {
      heading:"Project Cargo Movement",
      text:"Handling oversized machinery or specialized equipment safely."
    },
     {
      heading:"Inventory Replenishment",
      text:"Regular transport to maintain inventory levels across multiple sites."
    },
     {
      heading:"Export & Import Logistics",
      text:"Coordinating shipments to and from ports with documentation support."
    }
  ],
  chooseImg:chooseIndustry1,
  chooseTitle:"Why Manufacturing & Engineering Companies Choose Shivam Transworld",
  chooseDesc:"Our expertise, strong fleet network, and industry-focused logistics solutions make us a trusted and dependable logistics partner for manufacturing and engineering businesses, supporting smooth operations, timely deliveries, and long-term growth across diverse sectors.",
  choosePoints:[
    "Customized logistics solutions for operational efficiency",
    "Pan-India coverage with strong fleet network",
    "Timely, safe, and reliable delivery",
    "Experienced team managing complex shipments",
    "Trusted by leading manufacturers and engineering companies"
  ],
  ctaImage:ctaIndustry1,
  ctaTitle:"Looking for a Reliable Logistics Partner for Your Manufacturing Operations?",
  ctaText:"Ensure smooth, cost-effective, and timely movement of materials and finished products with Shivam Transworld. Connect with us today for a tailored logistics solution that fits your manufacturing needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Importers & Exporters",
        metaDesc:"End-to-end logistics support for importers and exporters, including first-mile, last-mile, and multimodal transportation solutions by Shivam Transworld.",
        slug:"importers-exporters",
        title:"Importers & Exporters",
        icon: <FiGlobe />,
        image:industry2,
        pageheading:"Logistics Solutions for Importers & Exporters",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld provides reliable and integrated logistics solutions for importers and exporters, ensuring smooth movement of goods between ports, factories, warehouses, and final destinations. With strong Pan-India connectivity and experienced coordination, we help businesses manage international trade logistics efficiently, compliantly, and on schedule.",
        challengeTitle:"Transportation Challenges in Import & Export Logistics",
        challengeDesc:"Import and export operations involve multiple stakeholders, tight timelines, and strict compliance requirements across various stages of the supply chain. Efficient and well-coordinated transportation plays a critical role in avoiding delays, minimizing risks, reducing additional costs, and ensuring smooth international trade operations.",
        challengePoints:[{
      icon:<FiAnchor />,
      heading: "Port & ICD Coordination",
      text: "Managing timely pickups and deliveries from ports, ICDs, and CFS locations.",
    },
    {
      icon:<FiClock/>,
      heading: "Time-Critical Shipments",
      text: "Meeting vessel cut-offs, delivery schedules, and transit commitments.",
    },
    {
      icon:<FiLayers />,
      heading: "Multiple Handling Points",
      text: "Coordinating movements across ports, warehouses, factories, and distribution centers.",
    },
   {
      icon:<FiFileText/>,
      heading: "Compliance & Documentation Dependencies",
      text: "Aligning transportation with customs clearance and regulatory processes.",
    },
  ],
  supportTitle:"How We Support Importers & Exporters",
  supportDesc:"We offer end-to-end transportation support tailored to the unique needs of importers and exporters, ensuring seamless connectivity, reliable coordination, and smooth cargo movement across the entire supply chain.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk import and export consignments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective solutions for smaller or regular shipments."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Smooth movement between ports, warehouses, and business locations."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        " Reliable pickup and final delivery for international trade cargo."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to factories, warehouses, or storage facilities."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Import & Export",
  useCaseDesc:"Our logistics services support a wide range of import and export scenarios, ensuring efficiency, visibility, and complete control at every stage of the transportation and delivery process, from port handling to final destination.",
  useCasePoints:[
    {
      heading:"Port-to-Factory Movement",
      text:"Transporting imported goods from ports or ICDs to manufacturing units."
    },
     {
      heading:"Factory-to-Port Dispatch",
      text:"Ensuring timely movement of export cargo to meet vessel schedules."
    },
     {
      heading:"Containerized Cargo Transportation",
      text:"Handling both full and partial container movements."
    },
     {
      heading:"Bulk & Breakbulk Shipments",
      text:" Managing large-volume or non-containerized cargo."
    },
     {
      heading:"Cross-Regional Distribution",
      text:"Moving imported goods across multiple domestic markets."
    },
     {
      heading:"Export Supply Chain Support",
      text:"Coordinating domestic transportation for international shipments."
    }
  ],
  chooseImg:chooseIndustry2,
  chooseTitle:"Why Importers & Exporters Choose Shivam Transworld",
  chooseDesc:"With a deep understanding of trade logistics and strong domestic transportation capabilities, we act as a dependable and trusted logistics partner for importers and exporters, ensuring smooth coordination, timely deliveries, and reliable execution across domestic and international supply chains.",
  choosePoints:[
    "Pan-India port and inland connectivity",
    "Reliable first-mile and last-mile logistics support",
    "Timely movement aligned with customs processes",
    "Experienced coordination for trade-related shipments",
    "Trusted by exporters, importers, and freight forwarders"
  ],
  ctaImage:ctaIndustry2,
  ctaTitle:"Looking for a Reliable Logistics Partner for Import & Export Operations?",
  ctaText:"Ensure smooth and timely movement of your import and export cargo with a logistics partner you can trust. Connect with Shivam Transworld today for customized transportation solutions designed to support your international trade operations.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for MSMEs & Enterprises",
        metaDesc:"Flexible transportation and logistics solutions designed to support MSMEs and large enterprises across India by Shivam Transworld.",
        slug:"msmes-enterprises",
        title:"MSMEs & Enterprises",
        icon: <FiBriefcase/>,
        image:industry3,
        pageheading:"Logistics Solutions for MSMEs & Enterprises",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld offers flexible and scalable logistics solutions designed to support the diverse transportation needs of MSMEs and large enterprises. With Pan-India coverage, a strong fleet network, and customized service models, we help businesses move goods efficiently, control costs, and maintain smooth supply chain operations as they grow.",
        challengeTitle:"Transportation Challenges for MSMEs & Enterprises",
        challengeDesc:"MSMEs and enterprises often face unique logistics challenges due to varying shipment sizes, frequent movements, and expanding market reach, making it essential to have a flexible, reliable, and well-coordinated transportation partner to support smooth operations.",
        challengePoints:[{
      icon:<FiDollarSign />,
      heading: "Cost Optimization",
      text: "Managing transportation costs while maintaining service reliability.",
    },
    {
      icon:<FiBarChart2 />,
      heading: "Variable Shipment Volumes",
      text: "Handling both small, frequent shipments and large bulk consignments.",
    },
    {
      icon:<FiMapPin />,
      heading: "Multiple Delivery Locations",
      text: "Coordinating deliveries across cities, regions, or states.",
    },
   {
      icon:<FiClock />,
      heading: "Timely & Reliable Delivery",
      text: "Meeting customer commitments and operational timelines consistently.",
    },
  ],
  supportTitle:"How We Support MSMEs & Enterprise Operations",
  supportDesc:"We provide end-to-end logistics support tailored to the operational scale and business goals of MSMEs and enterprises, ensuring flexibility, efficiency, cost control, and reliable transportation solutions that grow seamlessly alongside their evolving business needs.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk shipments and large consignments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective shared transport for regular smaller movements."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Smooth management of goods moving in and out of business locations."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup and final delivery across diverse locations."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to factories, warehouses, and storage facilities."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases for MSMEs & Enterprises",
  useCaseDesc:"Our logistics solutions support a wide range of business scenarios, helping MSMEs and enterprises operate efficiently, maintain smooth supply chain operations, and scale with confidence as their business expands.",
  useCasePoints:[
    {
      heading:"Raw Material Transportation",
      text:"Moving materials from suppliers to production or storage facilities."
    },
     {
      heading:"Finished Goods Distribution",
      text:"Delivering products to distributors, retailers, or customers."
    },
     {
      heading:"Inter-Branch Transfers",
      text:" Transporting goods between multiple warehouses or business locations."
    },
     {
      heading:"Regular Replenishment Shipments",
      text:"Supporting ongoing inventory movement and stock balancing."
    },
     {
      heading:"Pan-India Market Expansion",
      text:"Enabling smooth logistics as businesses enter new regions."
    },
     {
      heading:"Seasonal or Peak Demand Support",
      text:"Managing increased shipment volumes during high-demand periods."
    }
  ],
  chooseImg:chooseIndustry3,
  chooseTitle:"Why MSMEs & Enterprises Choose Shivam Transworld",
  chooseDesc:"Our experience, flexibility, and strong operational network make us a preferred logistics partner for growing and established businesses.",
  choosePoints:[
    "Scalable logistics solutions for all business sizes",
    "Cost-effective and reliable transportation services",
    "Pan-India coverage with strong fleet support",
    "Timely deliveries with transparent coordination",
    "Trusted by MSMEs, enterprises, and growing brands"
  ],
  ctaImage:ctaIndustry3,
  ctaTitle:"Looking for a Reliable Logistics Partner for Your Business?",
  ctaText:"Whether you’re a growing MSME or a large enterprise, Shivam Transworld provides logistics solutions that adapt to your needs. Connect with our team today for a customized quote and dependable transportation support.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Agriculture & Food Processing",
        metaDesc:"Efficient logistics and transportation support for agriculture and food processing businesses with time-sensitive delivery needs by Shivam Transworld.",
        slug:"agriculture-food-processing",
        title:"Agriculture & Food Processing",
        icon: <FiFeather />,
        image:industry4,
        pageheading:"Logistics Solutions for Agriculture & Food Processing",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld offers reliable and efficient logistics solutions for agriculture and food processing businesses, ensuring timely and safe movement of raw produce, processed goods, and packaged food products. With strong Pan-India connectivity and experienced coordination, we help agri and food businesses maintain product quality, reduce transit delays, and ensure consistent supply chain operations.",
        challengeTitle:"Transportation Challenges in Agriculture & Food Processing",
        challengeDesc:"Agriculture and food processing logistics require speed, meticulous care, and precise execution to maintain product freshness, ensure consistent quality, comply with safety and regulatory standards, and minimize losses throughout the supply chain.",
        challengePoints:[{
      icon:<FiThermometer />,
      heading: "Perishable Goods Handling",
      text: "Timely transportation is critical to prevent spoilage and quality loss.",
    },
    {
      icon:<FiTrendingUp/>,
      heading: "Seasonal Volume Fluctuations",
      text: "Managing sudden increases in shipment volumes during harvest or peak seasons.",
    },
    {
      icon:<FiMap/>,
      heading: "Rural & Remote Pickups",
      text: "Coordinating first-mile pickups from farms and rural production locations.",
    },
   {
      icon:<FiShield />,
      heading: "Quality & Safety Compliance",
      text: "Ensuring hygienic handling and adherence to food safety standards during transit.",
    },
  ],
  supportTitle:"How We Support Agriculture & Food Processing Operations",
  supportDesc:"We provide end-to-end logistics support tailored to the specific needs of agriculture and food processing businesses, offering customized transportation solutions, real-time monitoring, and reliable coordination to ensure the safe, timely, and efficient movement of perishable and non-perishable goods across the entire supply chain.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk agri produce and processed food consignments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective shared transport for smaller, frequent shipments."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Smooth movement from farms and suppliers to processing units and markets."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup from farms and delivery to factories, godowns, or buyers."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        " Direct transportation to processing units, warehouses, and storage facilities."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Food & Agriculture",
  useCaseDesc:"Our comprehensive logistics solutions support a wide range of agri and food supply chain requirements with efficiency, precision, and care, ensuring timely transportation, safe handling, quality preservation, and seamless coordination across farms, processing units, warehouses, and markets.",
  useCasePoints:[
    {
      heading:"Farm-to-Factory Movement",
      text:"Transporting raw agricultural produce to processing facilities."
    },
     {
      heading:"Factory-to-Market Distribution",
      text:" Delivering processed and packaged food products to distributors and retailers."
    },
     {
      heading:"Bulk Commodity Transport",
      text:"Handling grains, pulses, spices, and other agri commodities."
    },
     {
      heading:"Seasonal Harvest Logistics",
      text:"Managing increased transportation demand during peak harvest periods."
    },
     {
      heading:"Inter-State Food Distribution",
      text:"Moving food products across regions with reliable transit timelines."
    },
     {
      heading:"Export-Oriented Food Logistics",
      text:"Supporting domestic transportation for food export shipments."
    }
  ],
  chooseImg:chooseIndustry4,
  chooseTitle:"Why Agriculture & Food Processing Businesses Choose Shivam Transworld",
  chooseDesc:"Our extensive experience, industry knowledge, and dependable logistics execution make us a trusted and reliable partner for agri and food supply chains, ensuring timely deliveries, safe handling, and efficient operations across every stage of the transportation process.",
  choosePoints:[
    "Reliable transportation for time-sensitive consignments",
    "Strong first-mile and last-mile connectivity",
    "Pan-India coverage with flexible vehicle options",
    "Focus on safety, hygiene, and timely delivery",
    "Trusted by food processors, traders, and agri businesses"
  ],
  ctaImage:ctaIndustry4,
  ctaTitle:"Looking for a Reliable Logistics Partner for Food & Agri Transport?",
  ctaText:"Ensure safe, timely, and efficient movement of your agricultural and food products with a logistics partner you can trust. Connect with Shivam Transworld today for customized food and agri logistics solutions tailored to your business needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Pharmaceuticals & Healthcare",
        metaDesc:"Reliable logistics solutions supporting safe and timely transportation for pharmaceutical and healthcare businesses by Shivam Transworld.",
        slug:"pharmaceuticals-healthcare",
        title:"Pharmaceuticals & Healthcare",
        icon: <FiActivity />,
        image:industry5,
        pageheading:"Logistics Solutions for Pharmaceuticals & Healthcare",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld provides specialized logistics solutions for pharmaceuticals and healthcare businesses, ensuring safe, timely, and compliant movement of medicines, medical equipment, and healthcare supplies. With temperature-controlled transport options, strong Pan-India connectivity, and experienced handling, we help healthcare providers and pharmaceutical companies maintain product integrity and meet strict regulatory standards.",
        challengeTitle:"Transportation Challenges in Pharmaceuticals & Healthcare",
        challengeDesc:"Pharma and healthcare logistics involve high-value, time-sensitive, and highly regulated shipments that demand exceptional speed, precision, meticulous handling, and strict adherence to national and international regulatory standards to ensure product safety, efficacy, and integrity throughout the entire supply chain.",
        challengePoints:[{
      icon:<FiThermometer/>,
      heading: "Temperature-Sensitive Shipments",
      text: "Maintaining cold chain for vaccines, medicines, and biologics.",
    },
    {
      icon:<FiFileText />,
      heading: "Regulatory Compliance",
      text: " Adhering to healthcare, safety, and pharmaceutical transportation regulations.",
    },
    {
      icon:<FiClock />,
      heading: "Time-Critical Deliveries",
      text: "Ensuring medicines and healthcare supplies reach hospitals, pharmacies, and distributors on schedule.",
    },
   {
      icon:<FiShield />,
      heading: "Secure & Safe Handling",
      text: "Preventing damage, tampering, or contamination during transport.",
    },
  ],
  supportTitle:"How We Support Pharma & Healthcare Logistics",
  supportDesc:"We provide end-to-end logistics support for the pharmaceutical and healthcare sector, offering customized solutions, temperature-controlled transport, real-time tracking, and meticulous handling to ensure safe, fully compliant, and timely transportation of medicines, vaccines, medical equipment, and other critical healthcare supplies across the entire supply chain.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk pharmaceutical and healthcare consignments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for smaller, frequent shipments."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Seamless management of materials moving into and out of healthcare facilities and warehouses."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        " Reliable pickup and delivery to hospitals, clinics, pharmacies, and distribution centers."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to manufacturing units, warehouses, or storage facilities."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Pharma & Healthcare",
  useCaseDesc:"Our comprehensive logistics services support a wide variety of healthcare and pharmaceutical operations, ensuring timely, secure, and fully compliant supply chain management, while maintaining product integrity, temperature control, and efficient delivery from manufacturers to distributors, hospitals, and pharmacies.",
  useCasePoints:[
    {
      heading:"Medicine Distribution",
      text:"Transporting medicines to pharmacies, hospitals, and clinics."
    },
     {
      heading:"Vaccine & Biologics Delivery",
      text:"Ensuring cold chain compliance for temperature-sensitive products."
    },
     {
      heading:"Medical Equipment Movement",
      text:"Safe and secure transport of medical devices and machinery."
    },
     {
      heading:"Bulk Raw Material Transport",
      text:" Moving pharmaceutical ingredients from suppliers to manufacturing units."
    },
     {
      heading:"Inter-Hospital Transfers",
      text:"Timely delivery of healthcare supplies between facilities."
    },
     {
      heading:"Export & Import Logistics",
      text:"Coordinating domestic movement for international pharmaceutical shipments."
    }
  ],
  chooseImg:chooseIndustry5,
  chooseTitle:"Why Pharmaceutical & Healthcare Companies Choose Shivam Transworld",
  chooseDesc:"Our extensive expertise, robust and specialized fleet, and deep regulatory knowledge make us a trusted and dependable partner for pharmaceutical and healthcare logistics, ensuring safe, compliant, and timely transportation of sensitive medicines, vaccines, medical equipment, and healthcare supplies across the entire supply chain.",
  choosePoints:[
    "Reliable cold chain and temperature-controlled transport",
    "Pan-India coverage with strong fleet support",
    "Timely, safe, and compliant delivery of sensitive shipments",
    "Experienced team handling healthcare and pharma logistics",
    "Trusted by hospitals, distributors, and pharmaceutical manufacturers"
  ],
  ctaImage:ctaIndustry5,
  ctaTitle:"Looking for a Reliable Logistics Partner for Healthcare Transport?",
  ctaText:"Ensure safe, timely, and compliant movement of your pharmaceutical and healthcare shipments with Shivam Transworld. Connect with us today for customized logistics solutions that meet your healthcare transportation needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Automobile & Auto Components",
        metaDesc:"Transportation and logistics support for automobile and auto component manufacturers with bulk and time-bound movement needs by Shivam Transworld.",
        slug:"automobile-auto-components",
        title:"Automobile & Auto Components",
        icon: <FiTruck />,
        image:industry6,
        pageheading:"Logistics Solutions for Automobile & Auto Components",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld provides specialized logistics solutions for the automobile and auto components industry, ensuring safe, timely, and cost-effective transportation of vehicles, parts, and components. With a strong Pan-India network, customized handling solutions, and experienced operations teams, we help automotive businesses maintain smooth supply chains and meet production and delivery deadlines efficiently.",
        challengeTitle:"Transportation Challenges in Automobile & Auto Components",
        challengeDesc:"Automobile logistics requires meticulous planning, careful handling of high-value and sensitive components, precise timing, and strict coordination across multiple supply chain points to ensure smooth production, on-time deliveries, minimal damage, and seamless operations from suppliers to factories and dealerships.",
        challengePoints:[{
      icon:<FiTruck />,
      heading: "High-Value Cargo Handling",
      text: "Safe transport of vehicles, engines, and critical auto components.",
    },
    {
      icon:<FiClock />,
      heading: "Time-Sensitive Deliveries",
      text: "Meeting production schedules, dealer shipments, and customer expectations.",
    },
    {
      icon:<FiLayers/>,
      heading: "Complex Supply Chains",
      text: "Coordinating movement across manufacturers, suppliers, warehouses, and dealers.",
    },
   {
      icon:<FiShield />,
      heading: "Damage & Safety Risks",
      text: "Ensuring secure packaging, handling, and transit to prevent damage or loss.",
    },
  ],
  supportTitle:"How We Support Automotive Logistics Operations",
  supportDesc:"We provide end-to-end logistics support for the automotive sector, ensuring efficient, secure, reliable, and timely transportation at every stage of the supply chain, from raw material movement to component deliveries and finished vehicle distribution.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk auto components or complete shipments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective solutions for smaller, frequent component movements."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Streamlining the movement of parts from suppliers to factories and finished goods to distributors."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup from suppliers and final delivery to factories, warehouses, or dealers."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to production units, storage facilities, and dealerships."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Auto & Components Transport",
  useCaseDesc:"Our comprehensive logistics solutions support diverse automotive operations, ensuring smooth and timely production, seamless assembly, and efficient delivery of vehicles, components, and spare parts while maintaining safety, quality, and operational reliability across the entire supply chain.",
  useCasePoints:[
    {
      heading:"Engine & Component Transport",
      text:" Safe movement of engines, gearboxes, and sensitive components."
    },
     {
      heading:"Vehicle Distribution",
      text:"Transporting finished vehicles to dealerships or end customers."
    },
     {
      heading:"Raw Material Movement",
      text:"Inbound logistics for steel, plastics, and other manufacturing inputs."
    },
     {
      heading:"Spare Parts Distribution",
      text:"Timely delivery of spare parts to service centers and warehouses."
    },
     {
      heading:"Project Cargo & Heavy Equipment",
      text:"Specialized transport for large automotive machinery."
    },
     {
      heading:"Export & Import Logistics",
      text:"Domestic transport support for international shipments of vehicles and components."
    }
  ],
  chooseImg:chooseIndustry6,
  chooseTitle:"Why Automobile Companies Choose Shivam Transworld",
  chooseDesc:"Our extensive expertise, versatile and well-maintained fleet, and industry-focused logistics solutions make us a trusted and dependable partner for the automotive sector, ensuring safe, timely, and cost-effective transportation of vehicles, parts, and components across complex supply chains.",
  choosePoints:[
    "Specialized handling of high-value auto components",
    "Timely deliveries aligned with production schedules",
    "Pan-India coverage with strong operational support",
    "Secure and safe transport minimizing damage risks",
    "Trusted by manufacturers, dealers, and auto component suppliers"
  ],
  ctaImage:ctaIndustry6,
  ctaTitle:"Looking for a Reliable Logistics Partner for Automotive Transport?",
  ctaText:"Ensure smooth, timely, and secure movement of your vehicles and auto components with Shivam Transworld. Connect with our team today for tailored logistics solutions designed to meet your automotive transportation needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Infrastructure & Construction",
        metaDesc:"Specialized transportation and logistics solutions supporting infrastructure and construction projects across India by Shivam Transworld.",
        slug:"infrastructure-construction",
        title:"Infrastructure & Construction",
        icon: <FiTool />,
        image:industry7,
        pageheading:"Logistics Solutions for Infrastructure & Construction",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld offers specialized logistics solutions for the infrastructure and construction sector, ensuring the safe, timely, and cost-effective transportation of materials, machinery, and equipment. With a strong Pan-India network, experienced operations teams, and customized handling solutions, we help construction businesses maintain project timelines, optimize supply chains, and reduce operational delays.",
        challengeTitle:"Transportation Challenges in Infrastructure & Construction",
        challengeDesc:"Infrastructure and construction logistics involve complex and often oversized shipments, heavy machinery, and time-sensitive deliveries that demand careful planning, precise execution, specialized equipment, and coordinated management to ensure projects stay on schedule, safe, and within budget.",
        challengePoints:[{
      icon:<FiTruck />,
      heading: "Oversized & Heavy Equipment Handling",
      text: "Transporting cranes, loaders, and other large machinery safely and efficiently.",
    },
    {
      icon:<FiClock />,
      heading: "Time-Critical Deliveries",
      text: "Meeting project schedules and milestone deadlines for construction sites.",
    },
    {
      icon:<FiPackage/>,
      heading: "Multiple Material Types",
      text: "Coordinating movement of cement, steel, aggregates, and other construction materials.",
    },
   {
      icon:<FiMapPin />,
      heading: "Remote & Challenging Locations",
      text: "Managing deliveries to sites with limited accessibility or difficult terrain.",
    },
  ],
  supportTitle:"How We Support Infrastructure & Construction Projects",
  supportDesc:"We provide end-to-end logistics support tailored to the unique needs of construction and infrastructure projects, offering customized transportation solutions, specialized handling, real-time tracking, and meticulous coordination to ensure smooth, safe, and timely movement of materials, machinery, and equipment across every stage of the project lifecycle.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk materials and large equipment consignments."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for smaller, regular shipments of construction materials."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        " Seamless management of material inflows and project deliveries."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup from suppliers and delivery to construction sites."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to construction sites, warehouses, or storage facilities."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Infrastructure Projects",
  useCaseDesc:"Our comprehensive logistics solutions support a wide range of infrastructure and construction operations, helping projects stay on schedule, remain within budget, and maintain operational efficiency, while ensuring the safe, timely, and reliable movement of materials, machinery, and equipment across challenging and remote locations.",
  useCasePoints:[
    {
      heading:"Heavy Machinery Transport",
      text:"Safe movement of cranes, excavators, and other large equipment."
    },
     {
      heading:"Building Material Supply",
      text:" Timely delivery of cement, steel, bricks, and aggregates."
    },
     {
      heading:"Prefabricated Component Transport",
      text:"Efficient handling of pre-cast concrete and modular construction elements."
    },
     {
      heading:"Project-Specific Material Coordination",
      text:"Coordinating shipments to meet specific project timelines."
    },
     {
      heading:"Inter-Site Material Transfers",
      text:"Moving materials between multiple construction sites or storage locations."
    },
     {
      heading:"Export & Import Logistics",
      text:"Supporting domestic transportation for imported construction equipment and materials."
    }
  ],
  chooseImg:chooseIndustry7,
  chooseTitle:"Why Infrastructure & Construction Companies Choose Shivam Transworld",
  chooseDesc:"Our extensive industry expertise, versatile and well-maintained fleet network, and comprehensive, project-focused logistics solutions make us a trusted and preferred partner for construction and infrastructure businesses, ensuring timely deliveries, safe handling of materials and equipment, and seamless coordination across every stage of complex projects.",
  choosePoints:[
    "Specialized handling for heavy and oversized equipment",
    "Timely deliveries aligned with project milestones",
    "Pan-India coverage and reliable operational support",
    "Secure, safe, and efficient transport of materials",
    "Trusted by contractors, builders, and infrastructure developers"
  ],
  ctaImage:ctaIndustry7,
  ctaTitle:"Looking for a Reliable Logistics Partner for Construction Logistics?",
  ctaText:"Ensure smooth, safe, and timely movement of your construction materials and equipment with Shivam Transworld. Connect with our team today for tailored logistics solutions designed to meet your project requirements.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Chemical Industry | Shivam Transworld",
        metaDesc:"Safe and reliable logistics support for chemical manufacturers and distributors, ensuring efficient transportation by Shivam Transworld.",
        slug:"chemicals",
        title:"Chemical Manufacturers & Distributors",
        icon: <FiDroplet />,
        image:industry8,
        pageheading:"Logistics Solutions for Chemical Industry",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld provides specialized logistics solutions for the chemical industry, ensuring safe, compliant, and timely transportation of hazardous and non-hazardous chemicals. With expertise in handling sensitive materials, regulatory compliance, and risk management, we help chemical manufacturers, distributors, and industrial clients maintain efficient supply chains across India.",
        challengeTitle:"Transportation Challenges in Chemical Logistics",
        challengeDesc:"Chemical logistics involves transporting high-risk, hazardous, and sensitive materials that require specialized handling, strict regulatory compliance, advanced safety measures, and precise coordination to ensure product integrity, prevent accidents, and maintain an uninterrupted and reliable supply chain from manufacturers to end-users.",
        challengePoints:[{
      icon:<FiAlertTriangle />,
      heading: "Hazardous Material Handling",
      text: "Ensuring the safe transport of flammable, corrosive, or toxic chemicals.",
    },
    {
      icon:<FiShield/>,
      heading: "Regulatory Compliance",
      text: "Adhering to local, national, and international safety and environmental regulations.",
    },
    {
      icon:<FiArchive/>,
      heading: "Specialized Packaging & Storage",
      text: "Using approved containers and storage conditions to prevent contamination or spillage.",
    },
   {
      icon:<FiClock/>,
      heading: "Time-Sensitive Deliveries",
      text: "Coordinating shipments to meet production schedules and downstream supply chain requirements.",
    },
  ],
  supportTitle:"How We Support Chemical Industry Operations",
  supportDesc:"We provide end-to-end logistics support tailored to the unique and complex needs of the chemical sector, offering specialized handling, temperature and hazard-controlled transport, regulatory compliance, real-time tracking, and meticulous coordination to ensure safety, operational efficiency, and seamless execution at every stage of the supply chain.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk chemical consignments with safety and compliance measures."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for smaller, frequent chemical shipments."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Smooth movement of raw materials to plants and finished products to clients."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup and final delivery for chemical shipments."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct transportation to manufacturing units, warehouses, or distribution centers."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Chemical Transport",
  useCaseDesc:"Our comprehensive logistics services support a wide range of chemical industry operations, ensuring safe, secure, and efficient material movement while maintaining regulatory compliance, minimizing risks, and optimizing supply chain performance across production, storage, and distribution stages.",
  useCasePoints:[
    {
      heading:"Raw Chemical Transportation",
      text:"Moving industrial chemicals from suppliers to manufacturing units."
    },
     {
      heading:"Finished Product Distribution",
      text:" Delivering packaged chemicals to clients, distributors, or retailers."
    },
     {
      heading:"Hazardous Material Handling",
      text:"Safe movement of flammable, corrosive, or toxic substances."
    },
     {
      heading:"Bulk Liquid & Powder Transport",
      text:"Coordinating large-volume shipments with specialized tankers or containers."
    },
     {
      heading:"Export & Import Chemical Shipments",
      text:"Domestic support for international chemical cargo movements."
    },
     {
      heading:"Project & Industrial Supplies",
      text:"Transporting chemicals for industrial projects or large-scale applications."
    }
  ],
  chooseImg:chooseIndustry8,
  chooseTitle:"Why Chemical Companies Choose Shivam Transworld",
  chooseDesc:"Our extensive expertise, in-depth regulatory knowledge, and safety-focused approach make us a highly reliable and trusted logistics partner for the chemical sector, ensuring the secure, compliant, and efficient transportation of hazardous, sensitive, and high-value chemical products across the entire supply chain.",
  choosePoints:[
    "Specialized handling of hazardous and sensitive chemicals",
    "Compliance with all safety and environmental regulations",
    "Strong fleet and pan-India operational coverage",
    "Timely, safe, and secure deliveries",
    "Trusted by manufacturers, distributors, and industrial clients"
  ],
  ctaImage:ctaIndustry8,
  ctaTitle:"Looking for a Reliable Logistics Partner for Chemical Logistics?",
  ctaText:"Ensure safe, compliant, and efficient movement of your chemical products with Shivam Transworld. Connect with our team today for customized logistics solutions designed to meet your chemical transportation needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for Retail & Distribution",
        metaDesc:"Efficient transportation and logistics solutions supporting retail, trade, and distribution networks across India by Shivam Transworld.",
        slug:"retail-trade-distribution",
        title:"Retail,Trade & Distribution",
        icon: <FiShoppingCart/>,
        image:industry9,
        pageheading:"Logistics Solutions for Retail, Trade & Distribution",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld offers comprehensive logistics solutions for retail, trade, and distribution businesses, ensuring fast, reliable, and cost-effective movement of goods across the supply chain. With strong Pan-India coverage, a versatile fleet, and experienced operational teams, we help businesses maintain inventory flow, meet customer expectations, and streamline deliveries from warehouses to stores and end customers.",
        challengeTitle:"Transportation Challenges in Retail & Distribution",
        challengeDesc:"Retail and distribution logistics involve managing high-volume, time-sensitive shipments that require meticulous planning, precise execution, seamless coordination, and operational flexibility to meet dynamic market demands, ensure uninterrupted inventory flow, maintain customer satisfaction, and adapt to seasonal fluctuations and sudden changes in demand.",
        challengePoints:[{
      icon:<FiLayers />,
      heading: "High Shipment Volumes",
      text: "Managing large and frequent deliveries across multiple locations efficiently.",
    },
    {
      icon:<FiClock/>,
      heading: "Time-Sensitive Delivery Windows",
      text: "Ensuring products reach stores and customers on schedule.",
    },
    {
      icon:<FiBarChart2 />,
      heading: "Inventory & Stock Management",
      text: "Coordinating shipments to maintain optimal inventory levels.",
    },
   {
      icon:<FiMapPin/>,
      heading: "Multiple Delivery Points",
      text: "Handling distribution across retail stores, warehouses, and end consumers.",
    },
  ],
  supportTitle:"How We Support Retail & Trade Logistics",
  supportDesc:"We provide end-to-end logistics support for retail and trade operations, offering tailored transportation solutions, real-time tracking, and seamless coordination to ensure smooth, timely, and reliable movement of goods across the entire supply chain—from suppliers and warehouses to retail stores and end customers—while optimizing efficiency and minimizing delays.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk shipments to warehouses or major distribution centers."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for smaller, frequent shipments to retail stores or outlets"
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Managing the flow of goods from suppliers to warehouses and from warehouses to retail points."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup from suppliers and final delivery to stores or customers."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to warehouses, retail stores, or distribution hubs."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in Retail Distribution",
  useCaseDesc:"Our comprehensive logistics solutions support a wide variety of retail and trade operations, helping businesses efficiently manage inventory, streamline order fulfillment, ensure timely deliveries to stores and customers, optimize supply chain processes, and maintain high levels of operational efficiency and customer satisfaction across all distribution channels.",
  useCasePoints:[
    {
      heading:"Store Replenishment",
      text:"Regular movement of stock to retail stores for uninterrupted sales."
    },
     {
      heading:"E-commerce Fulfillment",
      text:" Fast delivery of products from warehouses to end customers."
    },
     {
      heading:"Bulk Warehouse Shipments",
      text:"Transport of large shipments to central distribution hubs."
    },
     {
      heading:"Seasonal & Peak Demand Logistics",
      text:"Handling increased shipment volumes during festivals or sales events."
    },
     {
      heading:"Inter-City Retail Transfers",
      text:"Moving goods between regional warehouses or stores."
    },
     {
      heading:"Export & Import Support",
      text:"Domestic transport for international retail shipments."
    }
  ],
  chooseImg:chooseIndustry9,
  chooseTitle:"Why Retail & Distribution Businesses Choose Shivam Transworld",
  chooseDesc:"Our extensive experience, highly scalable logistics solutions, and proven operational reliability make us a trusted and preferred logistics partner for retail and distribution companies, enabling them to manage high-volume shipments, meet tight delivery schedules, optimize inventory flow, and ensure a seamless supply chain across stores, warehouses, and end customers.",
  choosePoints:[
    "Fast and reliable deliveries across India",
    "Scalable solutions for both small and large shipments",
    "Flexible fleet options to suit diverse retail needs",
    "Efficient inventory and stock movement management",
    "Trusted by retailers, distributors, and e-commerce businesses"
  ],
  ctaImage:ctaIndustry9,
  ctaTitle:"Looking for a Reliable Logistics Partner for Retail Transport?",
  ctaText:"Ensure smooth, timely, and cost-effective movement of your retail and distribution shipments with Shivam Transworld. Connect with our team today for customized logistics solutions designed to meet your retail transportation needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    },
     {
        metaTitle:"Logistics Solutions for FMCG & Consumer Goods",
        metaDesc:"Reliable logistics and transportation solutions for FMCG and consumer goods businesses with high-volume distribution needs by Shivam Transworld.",
        slug:"fmcg-consumer-goods",
        title:"FMCG and Consumer Goods",
        icon: <FiPackage />,
        image:industry10,
        pageheading:"Logistics Solutions for FMCG & Consumer Goods",
        subheading:"INDUSTRIES WE SERVE",
        subText:"Shivam Transworld provides specialized logistics solutions for the FMCG and consumer goods sector, ensuring fast, reliable, and cost-effective transportation of products across the supply chain. With extensive Pan-India coverage, temperature-controlled options, and experienced operations teams, we help FMCG companies maintain inventory flow, meet retail deadlines, and satisfy end customers efficiently.",
        challengeTitle:"Transportation Challenges in FMCG & Consumer Goods",
        challengeDesc:"FMCG and consumer goods logistics involve high-volume, time-sensitive, and often perishable shipments that demand exceptional speed, precise planning, meticulous handling, and seamless coordination across multiple supply chain points to ensure on-time delivery, product integrity, and optimal customer satisfaction.",
        challengePoints:[{
      icon:<FiRepeat />,
      heading: "High-Frequency Deliveries",
      text: "Managing multiple daily shipments to retailers, distributors, and warehouses.",
    },
    {
      icon:<FiClock />,
      heading: "Time-Sensitive & Perishable Goods",
      text: "Ensuring timely delivery of products with limited shelf life.",
    },
    {
      icon:<FiTrendingUp />,
      heading: "Inventory & Demand Fluctuations",
      text: "Coordinating shipments to match changing consumer demand and stock levels.",
    },
   {
      icon:<FiGrid />,
      heading: "Multiple Distribution Channels",
      text: "Efficiently managing deliveries across retail stores, e-commerce, and distributors.",
    },
  ],
  supportTitle:"How We Support FMCG Logistics Operations",
  supportDesc:"We provide end-to-end logistics support for FMCG and consumer goods, offering customized transportation solutions, real-time tracking, temperature-controlled options, and seamless coordination to ensure smooth, reliable, and timely delivery across all channels—including retail stores, distributors, warehouses, and e-commerce platforms—while optimizing supply chain efficiency and maintaining product quality at every stage.",
  supportPoints:[
      {
      title: "Full Truck Load (FTL) Transportation",
      desc:
        "Dedicated vehicles for bulk FMCG consignments to warehouses or central distribution hubs."
    },
       {
      title: "Part Truck Load (PTL) Services",
      desc:
        "Cost-effective transport for smaller, frequent shipments to retailers or distributors."
    },
       {
      title: "Inbound & Outbound Logistics Coordination",
      desc:
        "Streamlining the movement of products from factories to warehouses and retail points."
    },
       {
      title: "First-Mile & Last-Mile Delivery Support",
      desc:
        "Reliable pickup from manufacturers and final delivery to stores or e-commerce fulfillment centers."
    },
       {
      title: "Door-to-Factory & Godown Delivery",
      desc:
        "Direct delivery to warehouses, retail stores, or distribution centers."
    },
  ],
   useCaseTitle:"Common Logistics Use Cases in FMCG Distribution",
  useCaseDesc:"Our comprehensive logistics solutions support a wide range of FMCG and consumer goods operations, ensuring timely delivery, efficient inventory management, streamlined order fulfillment, optimized supply chain processes, and seamless coordination across warehouses, distribution centers, retail outlets, and e-commerce channels while maintaining product quality and customer satisfaction.",
  useCasePoints:[
    {
      heading:"Retail Stock Replenishment",
      text:"Regular delivery of products to retail stores to prevent stockouts."
    },
     {
      heading:"E-commerce Fulfillment",
      text:"Fast and reliable delivery to online customers."
    },
     {
      heading:"Warehouse Consolidation",
      text:"Moving bulk shipments to central warehouses for redistribution."
    },
     {
      heading:"Seasonal & Promotional Campaign Logistics",
      text:"Handling high shipment volumes during sales or festive seasons."
    },
     {
      heading:"Inter-City Transfers",
      text:"Coordinating shipments between warehouses, distribution centers, and stores."
    },
     {
      heading:"Export & Import Support",
      text:"Domestic transport for goods linked to international FMCG shipments."
    }
  ],
  chooseImg:chooseIndustry10,
  chooseTitle:"Why FMCG Companies Choose Shivam Transworld",
  chooseDesc:"Our extensive expertise, highly agile and scalable logistics solutions, and proven operational reliability make us a trusted and preferred partner for FMCG and consumer goods logistics, enabling businesses to manage high-volume shipments, meet strict delivery timelines, maintain product quality, optimize supply chains, and consistently satisfy customers across diverse retail and distribution channels.",
  choosePoints:[
    "Timely deliveries across Pan-India network",
    "Flexible solutions for bulk and smaller shipments",
    "Temperature-controlled transport for perishable goods",
    "Efficient inventory and stock movement management",
    "Trusted by retailers, distributors, and e-commerce businesses"
  ],
  ctaImage:ctaIndustry10,
  ctaTitle:"Looking for a Reliable Logistics Partner for FMCG Transport?",
  ctaText:"Ensure smooth, timely, and cost-effective movement of your FMCG and consumer goods with Shivam Transworld. Connect with our team today for customized logistics solutions designed to meet your FMCG transportation needs.",
   cta: {
    secondary: {
      text: "Contact Us",
      link: "/contact-us",
    },
  }
    }
]

export const factCards=[
 {
    title:"Safe Logistics",
    desc:"Our logistics solutions are a streamline process, ensuring to reach at location smoothly & on-time.",
    icon: <FiTruck />,
 },
 {
    title:"Fast Delivery",
    desc:"Regular Export logistics solutions streamline the process, ensuring smooth & timely transportation.",
     icon: <FiClock />,
 },
 {
    title:"24/7 Assistance",
    desc:"Support for logistics solutions streamline the process, ensuring smooth & timely transportation.",
      icon: <FiHeadphones />,
 }
]

export const logistics = [
  { count: 11, suffix: "+", label: "Years of Experience", fill: 75 },
  { count: 1000, suffix: "+", label: "Vehicles in Fleet Network", fill: 80 },
  { count: 14, suffix: "", label: "Max Tyre Capacity", fill: 65 },
  { count: 20000, suffix: "+", label: "Clients & Partners", fill: 90 },
  { count: 12000, suffix: "+", label: "Pincodes Covered", fill: 85 },
];


export const CtaPoints=[
    {
        title:"Requirement Understanding",
        desc:"We assess your shipment type, volume, timelines, and business needs to plan the right logistics solution."
    },
     {
        title:"Vehicle & Route Planning",
        desc:"The most suitable vehicle and optimized route are selected to ensure efficiency and cost control."
    },
     {
        title:"Pickup & In-Transit Management",
        desc:"Shipments are monitored and coordinated throughout transit for smooth and uninterrupted movement."
    },
     {
        title:"Safe & Timely Delivery",
        desc:"Goods are delivered securely at the destination, on time and as committed."
    }
]

export const clientLogos=[
    {
        logo:clientLogo1
    },
     {
        logo:clientLogo2
    },
     {
        logo:clientLogo3
    },
     {
        logo:clientLogo4
    },
     {
        logo:clientLogo5
    },
     {
        logo:clientLogo6
    },
     {
        logo:clientLogo7
    },
     {
        logo:clientLogo8
    },
      {
        logo:clientLogo9
    },
     {
        logo:clientLogo10
    },
    /* {
        logo:clientLogo11
    },*/
     {
        logo:clientLogo12
    },
     {
        logo:clientLogo13
    },
     {
        logo:clientLogo14
    },
      {
        logo:clientLogo15
    },
     {
        logo:clientLogo16
    },
    /* {
        logo:clientLogo17
    },
     {
        logo:clientLogo18
    },
     {
        logo:clientLogo19
    },
     {
        logo:clientLogo20
    },
      {
        logo:clientLogo21
    },
     {
        logo:clientLogo22
    },
     {
        logo:clientLogo23
    },
     {
        logo:clientLogo24
    }*/
]

export const ourApproach=[
    {
        title:"Planning Before Execution",
        desc:"Every shipment is carefully planned to ensure smooth execution and minimal disruptions.",
        icon: <FiClipboard />
    },
    {
        title:"Cost, Timelines, Reliability",
        desc:"We balance optimized costs with committed timelines and dependable service delivery.",
        icon: <FiDollarSign />
    },
    {
        title:"First-mile to Last-mile Thinking",
        desc:"Logistics is managed end-to-end, from pickup at origin to final delivery.",
        icon: <FiMap />
    },
    {
        title:"Customer-specific Solutions",
        desc:"Transportation strategies are customized to match each customer’s unique business needs.",
        icon: <FiUserCheck />
    }
]

export const ourCapability=[
    {
        text:"Pan-India logistics coverage"
    },
     {
        text:"Strong network of 1000+ vehicles"
    },
     {
        text:"Vehicle range from 4-tyre to 14-tyre"
    },
     {
        text:"Door / godown delivery across India"
    },
     {
        text:"Multimodal capability (surface & air)"
    }
]